import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonDirective } from '@shared/directives/button.directive';

@Component({
  selector: 'app-page-not-found',
  standalone: true,
  imports: [ButtonDirective],
  templateUrl: './page-not-found.component.html',
  styleUrl: './page-not-found.component.scss',
})
export class PageNotFoundComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit(): void {}

  goBackToDashboard(): void {
    this.router.navigate(['/auth/login']);
  }
}
